import {PageSettingValue} from '@/plugins/api'

export default {
  namespaced: true,
  actions: {
    fetchPageSettingValue(_, params) {
      return PageSettingValue.fetch(params)
    }
  }
}
